import { SelectInput, Button } from "@life-line-lab/components-react";
import ModuleTitleBar from "Components/shared/module-title-bar";
import { toaster } from "Helpers/toaster";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const AssignServicePointModal = (props) => {
  const { sortingHubOptions, info, handleCancel, onSubmit } = props || {};
  const { t } = useTranslation();

  const [selectedServicePoint, setSelectedServicePoint] = useState<any>(
    info?.midMileInfo?.sortingHub,
  );

  const handleSubmit = () => {
    try {
      if (selectedServicePoint) {
        const payload = {
          orderID: info._id,
          returnInfo: { returnServicePoint: selectedServicePoint },
        };

        onSubmit(payload);
      } else {
        toaster("error", "Select at least one station");
      }
    } catch (e) {
      console.log("Unable to change");
    }
  };

  return (
    <div className="parcel-tracking-modal">
      <ModuleTitleBar titleText={"Diolko Review"} />
      <div className="mt-20">
        <SelectInput
          showSearch
          filterOption={(inputValue, option) =>
            option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
          }
          label={t("label.selectReturnStation")}
          options={sortingHubOptions?.map((point) => ({
            label: point?.locationName,
            value: point?._id,
          }))}
          isRequired
          value={selectedServicePoint}
          name="servicePoint"
          placeholder={t("txt.selectHere")}
          onChange={(value) => {
            setSelectedServicePoint(value);
          }}
        />
      </div>
      <div className="mt-30 right">
        <Button
          type={"primary"}
          label={t("action.confirm")}
          isDisabled={!selectedServicePoint}
          onClick={() => {
            console.log("service", selectedServicePoint);

            handleSubmit();
          }}
        />
        <Button
          className="cancel-btn"
          type={"default"}
          label={t("action.cancel")}
          onClick={() => {
            handleCancel();
          }}
        />
      </div>
    </div>
  );
};

export default AssignServicePointModal;
